/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Display_Default_Background_Color_LabelInputs */



/**
* | output |
* | --- |
* | "Default Background Color" |
*
* @param {Options_Display_Default_Background_Color_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_display_default_background_color_label = /** @type {((inputs?: Options_Display_Default_Background_Color_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Display_Default_Background_Color_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Couleur de fond par défaut")
	if (locale === "de") return /** @type {LocalizedString} */ ("Standard-Hintergrundfarbe")
	if (locale === "it") return /** @type {LocalizedString} */ ("Colore di sfondo predefinito")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Цвет фона по умолчанию")
	if (locale === "es") return /** @type {LocalizedString} */ ("Color de fondo predeterminado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("默认背景颜色")
	if (locale === "ja") return /** @type {LocalizedString} */ ("デフォルトの背景色")
	if (locale === "hi") return /** @type {LocalizedString} */ ("डिफ़ॉल्ट पृष्ठभूमि रंग")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cor de fundo predefinida")
	return /** @type {LocalizedString} */ ("Default Background Color")
});